import api from '@pray/shared/utils/api';
import { ObjectResponse } from '@pray/shared/utils/api/types/response';

type UploadBookProps = {
  artistId: string;
  fileUrl: string;
  bookName: string;
};

type UploadBookResponse = ObjectResponse<{ id: string; title: string }>;

export const uploadBook = async ({ artistId, fileUrl, bookName }: UploadBookProps) => {
  if (!artistId) throw Error('Artist ID is required');
  if (!fileUrl) throw Error('File URL is required');

  const url = `/web/studio/artists/${artistId}/books/upload`;
  const data = {
    book_file_url: fileUrl,
    book_name: bookName,
  };

  const response = await api.executePostRequest<UploadBookResponse>(url, data);
  return response.data;
};
